var _style, _path, _path2, _path3, _ellipse, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHsStudent = function SvgHsStudent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "hs-student_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 300 300"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".hs-student_svg__st3{fill:#89bff8}.hs-student_svg__st4{fill:#2d95f3}.hs-student_svg__st7{fill:#ffd040}")), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    style: {
      fill: "#ff6986"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271 211.1c-6.2-23.2 18.1-31.7-8.5-64.6s-8.1-33.1-26.7-78.2C218 25 150 25.8 150 25.8S82 25 64.2 68.3c-18.6 45.1 0 45.3-26.7 78.2-26.6 32.9-2.3 41.4-8.5 64.6-1.8 6.6-4.8 11.4-8.1 15.3C47.1 270.5 95.1 300 150 300s102.9-29.5 129.1-73.6c-3.3-3.9-6.3-8.8-8.1-15.3",
    className: "hs-student_svg__st7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 225.8h-84.2v26.6c.3 15.5-3.1 28.2-8.3 38.7 15.9 5.7 33 8.9 50.9 8.9 17.8 0 34.8-3.1 50.7-8.8-5.2-10.3-8.6-23-8.3-38.8z",
    className: "hs-student_svg__st3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m192.3 251.6-.8-25.8h-84.2v25.4c10.8 11.8 25 18.8 42.7 18.8 17.5 0 31.6-6.8 42.3-18.4",
    className: "hs-student_svg__st4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.9,
    cy: 165.9,
    className: "hs-student_svg__st3",
    rx: 22.3,
    ry: 17.6,
    transform: "rotate(-73.238 218.902 165.904)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.7 148.6c0 57.4-22.2 105.5-68.7 105.5S81.3 206 81.3 148.6 103.4 44.7 150 44.7s68.7 46.5 68.7 103.9",
    className: "hs-student_svg__st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m150 212-18.6-10.6c-.2 1-.3 2.1-.3 3.2 0 10.4 8.4 18.9 18.9 18.9s18.9-8.4 18.9-18.9c0-1.1-.1-2.1-.3-3.2z",
    className: "hs-student_svg__st4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.8 144.3c1.6-.1 2.9-1.4 2.9-3-1-59.6-29.9-104.9-89.7-104.9-32.3 0-55.5 14.1-70.2 36.3 13.4 15.4 30.9 30.1 51.8 42.8 36.1 21.9 74.3 29.6 105.2 28.8",
    className: "hs-student_svg__st7"
  })));
};
export default SvgHsStudent;